import { ProfileTitle } from '@components/Profile/ProfileTitle/ProfileTitle'
import useGoBackNavigation from '@hooks/useGoBackNavigation'
import React, { useCallback, useEffect, useRef } from 'react'
import './ProfileName.scss'
import { VelvetSDK } from 'sdk'
import Input from '@components/Input/Input'
import { SecondaryButton } from '@components/Buttons/SecondaryButton/SecondaryButton'
import { Params, useNavigate, useParams } from 'react-router-dom'
import { onEnterKeyPressAndClick } from '@utils/helpers'
import classNames from 'classnames'
import { useUserProfile } from '@hooks/useUserProfile'
import { useDispatch } from 'react-redux'
import { setProfileName } from '@actions/profileActions'
import { useTypedSelector } from 'store'

interface ProfileNameProps {
  showMenu: (status: boolean) => void
}

const ProfileName = ({ showMenu }: ProfileNameProps) => {
  const V = VelvetSDK.Vocabulary.vocabulary
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const saveButtonRef = useRef<HTMLButtonElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const { profileId } = useParams<Params>()
  const { profileData, isLoading } = useUserProfile({
    profileId: profileId || '',
  })
  const profileNameLocal = useTypedSelector((state) => state.profile.name)

  useGoBackNavigation()

  const handleSaveName = useCallback(
    (e: React.KeyboardEvent | React.MouseEvent) => {
      e.preventDefault()

      onEnterKeyPressAndClick(e, () => {
        if (!inputRef.current?.value) {
          navigate(-1)
        } else {
          dispatch(setProfileName(inputRef.current?.value))
          navigate(-1)
        }
      })
    },
    [dispatch, navigate],
  )

  const handleCancel = useCallback(() => {
    navigate(-1)
  }, [navigate])

  useEffect(() => {
    showMenu(false)
    inputRef.current && inputRef.current.focus()
  }, [showMenu, saveButtonRef])

  return (
    <div className={classNames('profile-name-container', isLoading && 'loading')}>
      <ProfileTitle title={V.editProfileName} />
      <div className="input-container">
        <Input
          type="text"
          placeholder={profileNameLocal || profileData?.name}
          className="focusable"
          inputRef={inputRef}
        />
      </div>
      <div className="buttons-container">
        <SecondaryButton buttonRef={saveButtonRef} onClick={handleSaveName}>
          {V.genericDoneLabel}
        </SecondaryButton>
        <SecondaryButton onClick={handleCancel}>{V.genericCancelLabel}</SecondaryButton>
      </div>
    </div>
  )
}

export default ProfileName
